import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { get } from 'services/api'
import { getDataField } from 'utils/constants/dataFields'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import history from 'utils/history'
import { cloneDeep } from 'lodash'

import DisplayAnswers from 'components/DueDiligence/Questions/DisplayAnswers'

import styles from './styles'

const initialValues = {
  address: {
    answer: {},
  },
  social_networks: { items: [] },
  financial_activities: { items: [] },
  environment_related_activities: { items: [] },
  external_activities: { items: [] },
  national_product_offering_activities: { items: [] },
  international_product_offering_activities: { items: [] },
  representation_activities: { items: [] },
  automation_activities: { items: [] },
  kinship_xp: { items: [] },
  pep_relationship: { items: [] },
  attorney_activities: { items: [] },
  third_party_investments: { investments_out_of_xp: {} },
  court_lawsuit_cvm_bacen_sfn: { items: [] },
  environmental_court_lawsuit: { items: [] },
  criminal_court_lawsuit: { items: [] },
  negative_media: { items: [] },
  restrictive_list: { items: [] },
  relation_with_another_companies: { items: [] },
  terms_agreement: { answer: {} },
}

const DueDiligenceResume = () => {
  const classes = styles()

  const token = useSelector((state) => state.auth.access_token)

  const [formResponses, setFormResponses] = useState(initialValues)

  const loadResponses = async () => {
    await get({ url: '/due_diligence/pf/form', token })
      .then((response) => {
        if (response.data.filled === false) {
          history.push(ROUTE_CONSTANTS.DUE_DILIGENCE)
          history.go()
        }
        const processedResponses = response.data.answers.map(
          (answer) => answer.answer_object,
        )

        const updatedValues = cloneDeep(initialValues)

        processedResponses.forEach((answer) => {
          updatedValues[answer.question_name].has_answer = true
          updatedValues[answer.question_name][
            getDataField(answer.question_name)
          ] = answer[getDataField(answer.question_name)]
        })

        setFormResponses(updatedValues)
      })
      .catch(() => {
        toast.error('Houve um erro ao carregar os dados de due diligence.')
      })
  }

  useEffect(() => {
    loadResponses()
  }, [])

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <header className={classes.header}>
          <h1>Respostas do formulário de inscrição</h1>
          <p>
            Seguem abaixo as respostas fornecidas no ato do preenchimento do
            formulário de inscrição para título de consulta. Não é mais possível
            alterar nenhuma das respostas.
          </p>
        </header>
        <DisplayAnswers formResponses={formResponses} />
      </div>
    </div>
  )
}

export default DueDiligenceResume
